import { createUseStyles } from 'react-jss';
import { grayPalette } from '@tcl-argon-colors/colors';
import { Classes } from 'jss';
import { AccentPalette, ActionPalette, GrayscalePalette } from '@tcl-boron-colors/colors';

export const useSingleDatePickerStyles: (data?: {
  theme?: Jss.Theme;
}) => Classes<
  | 'root'
  | 'calendarToggle'
  | 'calendarContainer'
  | 'open'
  | 'calendarInput'
  | 'calendarButtonContainer'
  | 'clearButton'
  | 'calendarButton'
> = createUseStyles({
  root: { position: 'relative' },
  calendarToggle: {
    borderRadius: '0px 3px 3px 0',
    boxShadow: 'none',
    // TODO find a better alternative to these magic numbers
    // This will break when someone uses a multi-line label
    position: 'absolute',
    right: '-2px',
    top: '27px',
  },
  calendarContainer: {
    backgroundColor: 'white',
    border: `1px solid ${grayPalette.gray30}`,
    display: 'none',
    left: 0,
    position: 'absolute',
    top: 'calc(100% + 10px)',
    width: '275px',
  },
  open: {
    display: 'flex',
    flexDirection: 'column',
    zIndex: 1,
  },
  calendarInput: { margin: '0 auto', paddingBottom: '24px' },
  calendarButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
  },
  clearButton: {
    border: 'none',
    backgroundColor: 'transparent',
    color: AccentPalette[100],
    marginTop: '12px',
    marginBottom: '24px',
    cursor: 'pointer',
  },
  calendarButton: {
    width: '30px',
    border: '3px solid transparent',
    height: '30px',
    display: 'flex',
    outline: 'none',
    alignItems: 'center',
    borderRadius: '50%',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    marginLeft: '3px',
    '&:hover': {
      backgroundColor: GrayscalePalette[200],
      cursor: 'pointer',
    },
    '&:focus-visible': {
      borderColor: ActionPalette[300],
    },
  },
});
